import RegistryModule from "@/components/RegistryModule";
import { fmtDate } from "@/lib/api";
import { PhoneCall } from "lucide-react";

export default function Appels() {
  return (
    <RegistryModule
      kind="calls"
      title="Journal des appels"
      subtitle="Appels entrants & sortants"
      icon={PhoneCall}
      emptyForm={{ sens: "Entrant", contact: "", telephone: "", objet: "", duree: 0, notes: "" }}
      fields={[
        { key: "sens", label: "Sens", type: "select", options: ["Entrant", "Sortant"], required: true },
        { key: "date", label: "Date", type: "date" },
        { key: "contact", label: "Contact / Interlocuteur", required: true },
        { key: "telephone", label: "Téléphone" },
        { key: "objet", label: "Objet", span: 2 },
        { key: "duree", label: "Durée (min)", type: "number" },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { label: "Date", render: (r) => <span className="text-sm">{fmtDate(r.date)}</span> },
        { label: "Sens", render: (r) => <span className="rounded bg-slate-100 px-2 py-0.5 text-xs">{r.sens}</span> },
        { label: "Contact", render: (r) => <span className="font-medium">{r.contact}</span> },
        { label: "Téléphone", render: (r) => <span className="text-sm font-mono">{r.telephone || "—"}</span> },
        { label: "Objet", render: (r) => <span className="text-sm text-slate-600">{r.objet || "—"}</span> },
        { label: "Durée", render: (r) => <span className="text-sm">{r.duree ? `${r.duree} min` : "—"}</span> },
      ]}
    />
  );
}
